// 九畴云市 · 一条业务主链数据

export interface ChainStep {
  id: string;
  label: string;
  detail: string;
}

export interface ChainStage {
  no: string;
  title: string;
  actor: string;
  icon: string;
  steps: ChainStep[];
}

export const businessChain: ChainStage[] = [
  {
    no: '第一步',
    title: '供应商 · 创建商品',
    actor: '供应商',
    icon: 'ri-box-3-line',
    steps: [
      { id: 'create', label: '创建商品', detail: '供应商在平台录入商品基础信息与资料。' },
      { id: 'submit', label: '提交资料', detail: '提交资质、品质、产地等材料供审核。' },
      { id: 'cert', label: '品质认证', detail: '平台对商品进行品质认证与标准化。' },
      { id: 'epin', label: 'ePin', detail: '生成商品唯一数字身份，一物一码。' },
      { id: 'lib', label: '进入商品库', detail: '认证通过后进入平台商品库，等待上架。' },
    ],
  },
  {
    no: '第二步',
    title: '数字货架 · 组织商品',
    actor: '平台',
    icon: 'ri-store-2-line',
    steps: [
      { id: 'pick', label: '选择商品', detail: '从商品库选择要上架的商品。' },
      { id: 'gen', label: '生成数字货架', detail: '将商品组织成结构化的数字货架。' },
      { id: 'config', label: '配置权益', detail: '配置红包、券等消费权益。' },
      { id: 'audit', label: '审核', detail: '平台审核货架内容与合规性。' },
      { id: 'on', label: '上架', detail: '审核通过，货架正式上线。' },
    ],
  },
  {
    no: '第三步',
    title: '云社员/云店 · 分发',
    actor: '云社员 · 云店',
    icon: 'ri-share-forward-line',
    steps: [
      { id: 'sel', label: '选择商品', detail: '云社员/云店从货架选择要推广的商品。' },
      { id: 'join', label: '加入数字货架', detail: '商品进入个人或店铺的数字货架。' },
      { id: 'share', label: '分享', detail: '通过社交渠道分享给消费者。' },
      { id: 'visit', label: '消费者访问', detail: '消费者通过分享链接访问商品。' },
    ],
  },
  {
    no: '第四步',
    title: '消费者 · 购买消费',
    actor: '消费者',
    icon: 'ri-shopping-cart-line',
    steps: [
      { id: 'browse', label: '浏览', detail: '消费者浏览商品详情与权益。' },
      { id: 'buy', label: '购买', detail: '确认购买，加入订单。' },
      { id: 'pay', label: '支付', detail: '使用红包、券、数字消费权益支付。' },
      { id: 'fulfill', label: '履约', detail: '到店或线上完成履约交付。' },
      { id: 'receive', label: '收货', detail: '消费者确认收货。' },
      { id: 'review', label: '评价', detail: '消费者评价，沉淀真实口碑。' },
    ],
  },
  {
    no: '第五步',
    title: '平台 · 清分对账',
    actor: '平台',
    icon: 'ri-flow-chart',
    steps: [
      { id: 'confirm', label: '订单确认', detail: '平台确认订单状态与履约完成。' },
      { id: 'recognize', label: '贡献识别', detail: '识别消费者、推荐人、供应链等多方贡献。' },
      { id: 'record', label: '数据记录', detail: '交易数据写入数据链，可追溯。' },
      { id: 'settle', label: '智能清分', detail: '按七方共利规则智能计算分配。' },
      { id: 'reconcile', label: '对账', detail: '清分结果对账，确保准确无误。' },
    ],
  },
  {
    no: '第六步',
    title: '产业 · 增值回流',
    actor: '产业',
    icon: 'ri-line-chart-line',
    steps: [
      { id: 'cdata', label: '消费数据', detail: '汇聚真实消费数据。' },
      { id: 'ai', label: 'AI 分析', detail: 'TOMA 对数据进行分析与洞察。' },
      { id: 'feedback', label: '需求反馈', detail: '将需求反馈到供应链与商家。' },
      { id: 'optimize', label: '供应链优化', detail: '优化供给结构，提升匹配效率。' },
      { id: 'value', label: '产业增值', detail: '形成产业增值，驱动再消费。' },
    ],
  },
];

export const chainClose = '消费 → 数据 → 产业 → 再消费';